// packages import
import { Autocomplete, TextField } from '@mui/material'
import { FC, useContext } from 'react'

// others
import { useLocation } from 'react-router-dom'
import { BillDeliveryMethod } from '../../../../../generated'
import { FinalBillsContext } from '../../../../context/FinalBillsContext'
import { PreBillsContext } from '../../../../context/PreBillsContext'
import { titleize } from '../../../../utils'

interface DeliveryOption {
  value: BillDeliveryMethod
  label: string
}

const deliveryOptions: DeliveryOption[] = Object.values(BillDeliveryMethod).map(method => ({
  value: titleize(method) as BillDeliveryMethod,
  label: titleize(method)
}))

const BillDeliveryFilter: FC = () => {
  const { pathname } = useLocation()
  const preBillsContext = useContext(PreBillsContext)
  const finalBillsContext = useContext(FinalBillsContext)

  const { filters, setFilters } = pathname.includes('pre-bill') ? preBillsContext : finalBillsContext
  const selectedDeliveryType = deliveryOptions.find(method => method.value === filters.billDeliveryType) || null

  const handleDeliveryTypeChange = (value: DeliveryOption | null) => {
    setFilters({ billDeliveryType: value?.value })
  }

  return (
    <Autocomplete
      sx={{ minWidth: 200 }}
      options={deliveryOptions}
      value={selectedDeliveryType}
      onChange={(_, value) => handleDeliveryTypeChange(value)}
      getOptionLabel={option => option.label}
      isOptionEqualToValue={(option, value) => option.value === value.value}
      renderInput={params => <TextField {...params} label="Bill Delivery Type" />}
    />
  )
}

export default BillDeliveryFilter
